import { CommonField, isNil } from '../util';
import { Field, RowError } from './model';

export function validatePermitType(...rows: ParsedRow[]) {
    rows.forEach(r => {
        if (r[Field.PermitType.name] < 1 || r[Field.PermitType.name] > 5) {
            r._invalid.add(RowError.InvalidPermitType);
        }
    });
}

export function validatePermitDescription(...rows: ParsedRow[]) {
    rows.forEach(r => {
        if (
            r[Field.PermitType.name] === 1 &&
            !r[Field.PermitDescription.name]
        ) {
            r._invalid.add(RowError.PermitDescriptionRequired);
        }
    });
}

export function validateHasRenewalDate(...rows: ParsedRow[]) {
    rows.forEach(r => {
        if (
            r[Field.PermitRenewalDate.name] === '' ||
            r[Field.PermitRenewalDate.name] === undefined
        ) {
            r[Field.PermitRenewalDate.name] = null;
        }
    });
}

export function validatePermitId(...rows: ParsedRow[]) {
    rows.forEach(r => {
        let regExp = new RegExp(/[^A-Za-z0-9-:#/.,)( ]+/);

        if (regExp.test(r[Field.PropertyPermitId.name])) {
            r._invalid.add(RowError.InvalidPermitId);
        }
    });
}

export function validateEffectiveDate(...rows: ParsedRow[]) {
    rows.forEach(r => {
        let effectiveDate = r[Field.PermitEffectiveDate.name];
        let renewalDate = r[Field.PermitRenewalDate.name];

        if (!isNil(effectiveDate) && !isNil(renewalDate)) {
            effectiveDate = new Date(effectiveDate).valueOf();
            renewalDate = new Date(renewalDate).valueOf();

            if (renewalDate < effectiveDate) {
                r._invalid.add(RowError.InvalidEffectiveDate);
            }
        }
    });
}

export function validatePermitQuantity(...rows: ParsedRow[]) {
    const groupedUnits = rows.reduce((g, r) => {
        const id = r[CommonField.UnitID] as number;
        if (!g.hasOwnProperty(id)) g[id] = [];
        g[id].push(r);
        return g;
    }, {} as Record<number, ParsedRow[]>);

    const invalidUnitIds: Array<string> = [];

    for (const unitGroup in groupedUnits) {
        if (groupedUnits[unitGroup].length > 5) {
            invalidUnitIds.push(unitGroup);
        }
    }

    rows.forEach(r => {
        if (
            invalidUnitIds.some(iui => iui === r[CommonField.UnitID].toString())
        ) {
            r._invalid.add(RowError.MaxPermitQuantityPerUnit);
        }
    });
}
